import type { IconProps } from '../types/IconProps.ts';
export const PaintBucket: IconProps = {
    name: 'PaintBucket',
    children: [
        `<path d="m10 5 2.3-2.3a1 1 0 0 1 1.4 0l6.95 6.95c.2.2.2.5 0 .7l-8.03 8.03a3 3 0 0 1-4.24 0l-3.76-3.76a3 3 0 0 1 0-4.24L7 8M8 3.5l3 3M4 12.5h14.5M19.98 15.06q.01-.03.04 0l1.35 4.04a1.44 1.44 0 1 1-2.74 0z" />`,
    ]
};